import { Badge } from '@/components/ui/Badge'
import type { ComponentProps } from 'react'

type Variant = ComponentProps<typeof Badge>['variant']

const STATUS_MAP: Record<string, { label: string; variant: Variant }> = {
  new:           { label: 'New',           variant: 'info' },
  reviewed:      { label: 'Reviewed',      variant: 'neutral' },
  contacted:     { label: 'Contacted',     variant: 'default' },
  estimate_sent: { label: 'Estimate Sent', variant: 'warning' },
  deposit_paid:  { label: 'Deposit Paid',  variant: 'success' },
  construction:  { label: 'Construction',  variant: 'success' },
  won:           { label: 'Won',           variant: 'success' },
  lost:          { label: 'Lost',          variant: 'danger' },
  archived:      { label: 'Archived',      variant: 'neutral' },
}

export function StatusBadge({ status }: { status: string }) {
  const map = STATUS_MAP[status] ?? { label: status, variant: 'neutral' as Variant }
  return <Badge variant={map.variant}>{map.label}</Badge>
}
